export default __webpack_public_path__ + "static/media/landing-page-image-6.df202f62.jpg";